import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CdnConfig } from '@app/core/model/cdn-config.model'
import { ChangeRequest } from '@app/core/model/change-request.model'
import { ScopeVersion } from '@app/core/model/scope-version'
import { ScopeElementsService } from '@app/shared/components/scope-elements/services/scope-elements.service'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { FetchDeliverablePayload } from '../../model'
import { MenuOptions } from '@app/core/model/definitions/menu-options.interface'
import { EditDeliverablePayload } from '../../model/edit-deliverable-payload.interface'
import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { ChangeRequestSelectors } from '../../store/selectors/change-request.selectors'
import { Store } from '@ngrx/store'

@Component({
  selector: 'change-request-tracked',
  templateUrl: './change-request-tracked.component.html',
})
export class ChangeRequestTrackedComponent {
  @Input() currentScope: ScopeVersion
  @Input() currentChangeRequest: ChangeRequest
  @Input() cdnConfig: CdnConfig

  @Input() mainColumnClass: string
  @Input() componentMainColumnClass: string
  @Input() roleMainColumnClass: string

  @Output() onFetchDeliverable = new EventEmitter<FetchDeliverablePayload>()
  @Output() onEditDeliverable = new EventEmitter<EditDeliverablePayload>()
  @Output() onDeleteDeliverable = new EventEmitter<Deliverable>()
  @Output() onDeleteComponent = new EventEmitter<ScopeComponent>()

  deliverables$ = this.store$.select(ChangeRequestSelectors.selectMappedUnsectionedTrackedDeliverables)
  sections$ = this.store$.select(ChangeRequestSelectors.selectMappedDeliverableSections(true))

  deliverableMenuOptions: MenuOptions[] = []
  componentMenuOptions: MenuOptions[] = []

  constructor(
    private store$: Store,
    protected scopeElementsService: ScopeElementsService
  ) {}

  fetchDeliverable(deliverableId: number) {
    this.onFetchDeliverable.emit({ scopeId: this.currentScope?.identity?.id, deliverableId })
  }
}
